export const toggleClass = function(className, e) {
  e.target.classList.toggle(className);
};

export const animateCSS = function(animationName, e, callback) {
  const node = e.target.element;

  if (e.percentInView === 1 && !node.classList.contains('animation-off')) {
    node.classList.add('animation-off', 'animated', animationName);

    function handleAnimationEnd() {
      node.classList.remove('animated', animationName);
      node.removeEventListener('animationend', handleAnimationEnd);
      if (typeof callback === 'function') callback();
    }

    node.addEventListener('animationend', handleAnimationEnd);
  }
};

export const getParsedQueryFromUrl = $route => {
  const query = $route.query;
  let parsedQuery = '';

  for (let key in query) {
    if (query.hasOwnProperty(key) && query[key] !== '') {
      parsedQuery += `${key}=${query[key]}&`;
    }
  }

  return parsedQuery;
};

export const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();


export function scrollToY(scrollTargetY, speed, easing) {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use

  var scrollY = window.scrollY || document.documentElement.scrollTop,
      scrollTargetY = scrollTargetY || 0,
      speed = speed || 2000,
      easing = easing || 'easeOutSine',
      currentTime = 0;

  // min time .1, max time .8 seconds
  var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  var easingEquations = {
      easeOutSine: function (pos) {
          return Math.sin(pos * (Math.PI / 2));
      },
      easeInOutSine: function (pos) {
          return (-0.5 * (Math.cos(Math.PI * pos) - 1));
      },
      easeInOutQuint: function (pos) {
          if ((pos /= 0.5) < 1) {
              return 0.5 * Math.pow(pos, 5);
          }
          return 0.5 * (Math.pow((pos - 2), 5) + 2);
      }
  };

  // add animation loop
  function tick() {
      currentTime += 1 / 60;

      var p = currentTime / time;
      var t = easingEquations[easing](p);

      if (p < 1) {
          requestAnimFrame(tick);

          window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
      } else {
          window.scrollTo(0, scrollTargetY);
      }
  }

  // call it once to get started
  tick();
}